// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  CLEAR_PATH_DATABASE_STATE,
  SET_PATH_DATABASE_DATA,
  SET_PATH_DATABASE_HIGHLIGHTED_IDS,
  SET_PATH_DETAILS_DATA,
} from './types'

export const clearPathDatabaseState = () => ({
  type: CLEAR_PATH_DATABASE_STATE,
})

export const setPathDatabaseData = data => ({
  type: SET_PATH_DATABASE_DATA,
  data,
})

export const setPathDatabaseHighlightedIds = (highlightedPathIds = []) => ({
  type: SET_PATH_DATABASE_HIGHLIGHTED_IDS,
  highlightedPathIds,
})

export const setPathDetailsData = (pathDetailsData) => ({
  type: SET_PATH_DETAILS_DATA,
  pathDetailsData,
})

